module.exports = __webpack_public_path__ + "img/10-3.a61aca0d.jpg";